import { render, staticRenderFns } from "./choosecloudphone.vue?vue&type=template&id=0954d925&scoped=true"
import script from "./choosecloudphone.vue?vue&type=script&lang=js"
export * from "./choosecloudphone.vue?vue&type=script&lang=js"
import style0 from "./choosecloudphone.vue?vue&type=style&index=0&id=0954d925&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954d925",
  null
  
)

export default component.exports